import { Image } from 'antd';
import logoLocalizame from '../../../../assets/logoLocalizame.png';
const LogoLocalizame = ({ style }: any) => { 

  return (    
      <Image preview={false} style={style} src={logoLocalizame} />
  )
}
 
export default LogoLocalizame;